export default __webpack_public_path__ + "static/media/marker.7dd5d347.svg";